<template>
  <div @keydown.enter.prevent.stop>
    <vue-editor
      :class="[classes]"
      v-model="localValue"
      :editorOptions="editorSettings"
      :editor-toolbar="customToolbar"
      @blur="onBlur"
      @focus="onFocus"
    />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor"

export default {
  name: "QuillEditor",
  components: {
    VueEditor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Object,
      default: () => ({
        theme: "snow",
        modules: {},
      }),
    },
    placeholder: {
      type: String,
      default: "Start typing here...",
    },
    classes: {
      type: [String, Array, Object],
      default: () => "quill",
    },
  },
  data() {
    return {
      localValue: "",
      editorSettings: {
        placeholder: this.placeholder,
      },
      customToolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    }
  },
  mounted() {
    this.localValue = this.value
  },
  computed: {
    computedOptions() {
      return {
        ...this.options,
        placeholder: this.placeholder,
      }
    },
  },
  watch: {
    value(val) {
      if (val !== this.localValue) {
        this.localValue = val
      }
    },
    localValue(val) {
      this.$emit("input", val)
      this.$emit("update:modelValue", val)
    },
  },
  methods: {
    onBlur(editor) {
      this.$emit("blur", editor)
    },
    onFocus(editor) {
      this.$emit("focus", editor)
    },
  },
}
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";

.quill-editor {
  .ql-editor {
    min-height: 250px;
  }
  .ql-toolbar {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .ql-container {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    margin-bottom: 2px;
  }

  &.input-error {
    .ql-toolbar {
      border: 2px solid var(--Red-500, #e24646) !important;
      border-bottom: 1px solid #ccc !important;
    }

    .ql-container {
      border: 2px solid var(--Red-500, #e24646) !important;
      border-top: 0 !important;
    }
  }
}
</style>
